/* eslint-disable no-underscore-dangle */
import * as types from "../consts";
import { SigninReducer } from "../interfaces";

const initState = {
  isEmailOk: false,
  emailApiResponse: {},
  isFirebaseOk: 2,
  firebaseRes: {},
  firebaseStatus: {},
  userRole: "",
};

export default function signinReducer(
  state = initState,
  action: SigninReducer
) {
  switch (action.type) {
    case types.GET_SIGNIN_EMAIL_SUCCESS: {
      return {
        ...state,
        isEmailOk: true,
        emailApiResponse: action.response,
      };
    }
    case types.GET_SIGNIN_EMAIL_ERROR: {
      return { ...state, status: action.error.status };
    }
    case types.GET_SIGNIN_EMAIL_REQUEST: {
      return { ...state, isEmailOk: false };
    }
    case types.FIREBASE_SIGNIN_PWD_SUCCESS: {
      const token = action.signin._tokenResponse.idToken;
      window.localStorage.setItem("token", token ?? "no data");
      return {
        ...state,
        userRole: action.signin.user.reloadUserInfo.customAttributes,
        firebaseRes: action,
        isFirebaseOk: 1,
      };
    }
    case types.FIREBASE_SIGNIN_PWD_ERROR: {
      return {
        ...state,
        firebaseStatus: action.error,
        firebaseRes: action,
        isFirebaseOk: 0,
      };
    }
    case types.FIREBASE_SIGNIN_PWD_REQUEST: {
      return { ...state, isFirebaseOk: 0 };
    }

    default: {
      return { ...state };
    }
  }
}
